import { type ComponentPropsWithoutRef, forwardRef } from "react";
import { cn } from "@/lib/utils";

export const LiquidActionButton = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<"button">
>(function LiquidActionButton({ className, children, ...props }, ref) {
  return (
    <button
      ref={ref}
      className={cn(
        "group relative flex items-center justify-center overflow-hidden border-none font-semibold shadow-[0_0_18px_rgba(168,85,247,0.3),0_10px_34px_rgba(15,23,42,0.2)] transition duration-300 select-none hover:scale-[1.025] hover:shadow-[0_0_28px_rgba(168,85,247,0.5),0_14px_44px_rgba(15,23,42,0.28)] active:scale-[0.98] disabled:pointer-events-none disabled:opacity-55 dark:shadow-[0_0_22px_rgba(168,85,247,0.4),0_10px_36px_rgba(0,0,0,0.5)]",
        className,
      )}
      {...props}
    >
      <span className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden rounded-[inherit]">
        <span className="liquid-action-spin relative h-[220%] w-[160%] shrink-0">
          <span className="liquid-action-orb-1 absolute top-[18%] left-[16%] size-20 rounded-full bg-[#ff007f] blur-[12px]" />
          <span className="liquid-action-orb-2 absolute right-[12%] bottom-[16%] size-24 rounded-full bg-[#00f0ff] blur-[12px]" />
          <span className="liquid-action-orb-3 absolute top-[16%] right-[22%] size-16 rounded-full bg-[#ffea00] blur-[12px]" />
          <span className="liquid-action-orb-4 absolute bottom-[16%] left-[22%] size-20 rounded-full bg-[#a000ff] blur-[12px]" />
          <span className="absolute top-1/2 left-1/2 size-16 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#00ff88] opacity-70 blur-[12px]" />
        </span>
      </span>
      <span className="pointer-events-none absolute inset-0 rounded-[inherit] border border-white/30 bg-white/15 shadow-[inset_0_2px_5px_rgba(255,255,255,0.35)] backdrop-blur-md dark:border-white/15 dark:bg-black/35" />
      <span className="pointer-events-none absolute inset-0 rounded-[inherit] bg-gradient-to-b from-white/30 to-transparent opacity-55 transition-opacity group-hover:opacity-100" />
      <span className="relative z-10 flex items-center justify-center">
        {children}
      </span>
    </button>
  );
});

LiquidActionButton.displayName = "LiquidActionButton";
